import { isRef, provide } from "vue";
import { useUserStore } from "@/authentication/user.store.js";
import { postEvent } from "@/tracking/analytics/api.ts";

export type AnalyticsData = {
  [key: string]: unknown;
};

export type AnalyticsMetadata = {
  [key: string]: unknown;
};

type UserStore = ReturnType<typeof useUserStore>

export class AnalyticsTracker {
  private readonly userStore: UserStore
  private readonly eventContext: AnalyticsData;

  constructor(eventContext?: AnalyticsData) {
    this.userStore = useUserStore()
    this.eventContext = eventContext || {}
  }

  getChildContext(newEventContext: AnalyticsData) {
    const child = new AnalyticsTracker(
      { ...this.eventContext, ...newEventContext }
    )
    provide('analytics', child)
    return child
  }

  removeContext(keys: string | string[]) {
    const keysToRemove = Array.isArray(keys) ? keys : [keys]
    const newContext = { ...this.eventContext }
    keysToRemove.forEach(key => delete newContext[key])
    
    const child = new AnalyticsTracker(newContext)
    provide('analytics', child)
    return child
  }

  sendEvent(eventName: string, eventData?: AnalyticsData) {
    const data = { ... this.eventContext, ...eventData }

    for (const key in data) {
      if (isRef(data[key])) {
        data[key] = data[key].value
      }
    }

    const eventPost = () => {
      const eventMetadata = this.userStore.eventMetadata
      postEvent(eventName, data, eventMetadata)
    }

    if (this.userStore.fetching) {
      this.userStore.pushOnetimeCallback(eventPost)
    } else {
      eventPost()
    }
  }
}